import { GraduationCap, Wrench, Monitor, Globe, Building, Rocket, Award, Compass, BookOpen } from 'lucide-react';

const eduIconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  university: GraduationCap,
  trade: Wrench,
  online: Monitor,
  'gap-year': Globe,
  community: Building,
  bootcamp: Rocket,
  fellowship: Award,
  entrepreneurship: Compass,
  'self-directed': BookOpen,
};

export const getEduIcon = (type: string) => {
  return eduIconMap[type] || GraduationCap;
};
